import { Component } from "@stencil/core";

/**
 * The `ch-tabular-grid-rowset-empty` component represents a container to "empty message" when ch-tabular-grid-rowset is empty.
 */
@Component({
  tag: "ch-tabular-grid-rowset-empty",
  styleUrl: "tabular-grid-rowset-empty.scss",
  shadow: false
})
export class ChTabularGridRowsetEmpty {}
